<template>
  <!---全体を囲む--->
  <div class="content-wrapper" v-if="isReadyToDraw">
    <div style="height: calc(100vh - 42px); overflow: scroll">
      <div class="recommendation_header">
        <div class="center">
          <p class="title">{{ recommendations.name }}</p>
          <p class="address">{{ recommendations.address }}</p>
        </div>
      </div>
      <div class="location-info">
        <div
          class="banner"
          v-if="recommendations.logo_url"
          :style="backgroundImageFromApi(recommendations.logo_url)"
        />
        <!-- FIXME: BACKSLASHとNLを置換するのは暫定対応。根本的な原因を探ってこんな置換処理は不要にしたい。 -->
        <div
          class="location-comment"
          v-if="recommendations.comment"
          v-html="
            newlineConvert(
              recommendations.comment
                .replace(/\[BACKSLASH\]/g, '')
                .replace(/\[NL\]/g, '<br>')
            )
          "
        ></div>
        <div class="info-list">
          <a v-if="recommendations.tel" @click="call(recommendations.tel)">
            <div class="list-item item__2">
              電話をかける: {{ recommendations.tel }}
            </div>
          </a>
          <a
            v-if="recommendations.uri"
            @click="goToExternalLink(recommendations.uri)"
          >
            <div class="list-item item__3">公式ウェブサイトを開く</div>
          </a>
        </div>
      </div>

      <div class="myTicket" v-if="dataList.length > 0">
        <div class="ribbon">
          <p>使う</p>
        </div>
        <div class="index" style="width: 96%">
          <div
            class="bookgroup_division"
            v-for="data in dataList"
            :key="data.bookGroup.id"
          >
            <ItemIndexBookPassSheet
              :bookGroup="data.bookGroup"
              :latestStampedAtOfBookGroup="data.latestStampedAtOfBookGroup"
            />
          </div>
        </div>
      </div>

      <div class="ticketStore">
        <div class="ribbon">
          <p>買う</p>
        </div>
        <div class="index">
          <div
            class="masterbook_division"
            v-for="masterBook in masterBooks"
            :key="masterBook.id"
            @click="goToBook(masterBook)"
          >
            <ItemIndexMasterBook
              v-if="masterBook.purchase_available"
              :imageUrl="masterBook.content.ticket_image_url"
              :name="masterBook.name"
              :price="masterBook.display_price"
            />
            <div class="cb"></div>
          </div>
        </div>
      </div>
    </div>

    <button
      @click="ncGotoPlaceRecommendation(recommendations)"
      class="bottom-button"
    >
      ここへ行く
    </button>
  </div>

  <!-- index画面の描画ローディング -->
  <ItemDialogForIndexPage v-else />
</template>

<script>
import storeJS from "@/store";

import { onMounted, ref, watchEffect, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";

import masterBookSetsService from "@/services/masterBookSets";
import masterBookService from "@/services/masterBook";
import bookGroupService from "@/services/bookGroup";
import nativeHandlerService from "@/services/nativeHandler";

// ネイティブから送られてくる情報をストアへ格納
window.jcSetRecommendInfo = function (info) {
  storeJS.commit("recommendations/setRecommendations", info);
};

export default {
  setup() {
    const store = useStore();
    const router = useRouter();

    const recommendations = computed(
      () => store.getters["recommendations/recommendations"]
    );
    const masterBookSets = computed(
      () => store.getters["ticketing/masterBookSets"]
    );

    // 賈う表示用データ
    const masterBooks = computed(() =>
      masterBookSetsService.forRecommendationIndex(
        masterBookSets.value,
        recommendations.value.master_books
      )
    );
    const dataList = ref([]);
    const isReadyToDraw = ref(false);

    onMounted(async () => {
      try {
        await API.getMasterBookSets();

        // 使う表示用データ
        recommendations.value.book_groups.forEach((bookGroup) => {
          const latestStampedAtOfBookGroup =
            bookGroupService.getLatestStampedAt(bookGroup.books[0]);
          dataList.value.push({
            bookGroup: bookGroup,
            latestStampedAtOfBookGroup: latestStampedAtOfBookGroup,
          });
        });
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "Recommendation/detail onMounted()",
          JSON.stringify(err)
        );
      }
    });

    watchEffect(() => {
      if (masterBooks.value.length > 0) {
        console.log("MB", masterBooks);
        isReadyToDraw.value = true;
      }
    });

    const goToBook = (masterBook) => {
      masterBookService.goToBook(masterBook, router);
    };

    const call = (tel) => {
      nativeHandlerService.ncCallPlace(tel);
    };

    return {
      masterBooks,
      dataList,
      isReadyToDraw,
      recommendations,
      goToBook,
      call,
    };
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  padding-bottom: 42px; /* 「ここへ行く」がある分、パディングを取る必要がある */
}

.recommendation_header {
  height: 64px;
  z-index: 99;
  padding: 0px 0px;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;
  .center {
    width: 100%;
    padding: 0 2%;
    .title {
      font: inherit;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 3px;
    }
    .address {
      font-size: 13px;
      padding-top: 5px;
      color: #888888;
    }
  }
}

.index {
  position: relative;
  clear: both;
  width: 100%;
  margin: auto;
}

.cb {
  clear: both;
}

.bookgroup_division {
  background: white;
  border: 1px solid #e0e0e0;
  margin-bottom: 15px;
  border-radius: 5px;
}
.myTicket {
  background: rgb(249, 249, 249);
  padding-bottom: 5px;
  .ribbon {
    background-image: url("~@/assets/img/icon/png/use.png");
    background-repeat: no-repeat;
    background-size: auto 18px;
    background-position: 10px 7px;
    padding-left: 15px;
    margin-bottom: 10px;
  }
}

.ticketStore {
  .ribbon {
    background-image: url("~@/assets/img/icon/png/purchase.png");
    background-repeat: no-repeat;
    background-size: auto 18px;
    background-position: 10px 7px;
    padding-left: 20px;
  }
}

.ribbon {
  background: #fdd000;
  border-top: 2px solid #ffb206;
  border-bottom: 2px solid #ffb206;
  padding-top: 6px;
  padding-bottom: 6px;
  p {
    padding: 5px 8px;
    padding-left: 30px;
    font-weight: bold;
    font-size: 13px;
  }
}

.location-info {
}

.banner {
  height: 95px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  border-right: none;
  border-left: none;
}

.location-comment {
  padding: 10px 2%;
  font-size: 13px;
  border-bottom: 1px solid #f5f5f5;
  line-height: 1.6;
}

.info-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  // height: 10vh;
  padding: 10px 10px;
  a {
    width: 100%;
  }
  a:first-child {
    .list-item {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
  a:last-child {
    .list-item {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
}

.list-item {
  font-size: 13px;
  color: black;
  font-weight: bold;
  width: 100%;
  padding-top: 0.8vh;
  margin: auto;
  text-align: center;
  border: 1px solid #e7e7e7;
  padding: 13px 0;
  margin: 0 auto;
}

.item__1 {
  top: 40%;
}

.item__2 {
}

.item__3 {
  border-top: none;
}

.list-item__header {
  font-size: 3vw;
  width: 35%;
  display: inline-block;
  text-align: center;
}

.open_for_business {
  background: #61d101;
  color: white;
  padding: 2px 4px;
  border-radius: 2px;
}

.bottom-button {
  background: #ffb206;
  width: 100%;
  display: block;
  border: none;
  /* margin: 0.5vw auto; */
  font-size: 13px;
  color: white;
  font-weight: bold;
  height: 42px;
  position: fixed;
  bottom: 0;
  border-radius: 0px 0px 10px 10px;
}
</style>
